(() => {
  'use strict';
  const card = document.getElementById('G24Thankyou');
  if (!card || card.dataset.ready) return;
  card.dataset.ready = 'true';
  const config = JSON.parse(document.getElementById('G24ThankyouConfig').textContent);
  const commerceURL = value => {
    try {
      const url = new URL(value, location.href);
      const path = url.pathname.replace(/\/+$/, '');
      const cartPath = (config.cartPath || '/cart').replace(/\/+$/, '');
      return url.origin === new URL(location.href).origin && (path === cartPath || /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkout|checkouts)(?:\/|$)/i.test(path));
    } catch (_) { return false; }
  };
  if (config.pageType === 'cart' || commerceURL(location.href)) { card.hidden = true; return; }
  const params = new URLSearchParams(location.search);
  const requested = params.get('g24_layer_preview');
  const preview = config.previewAllowed && ['layout', 'time', 'exit'].includes(requested);
  const iso = value => /^\d{4}-\d\d-\d\dT\d\d:\d\d(:\d\d)?(Z|[+-]\d\d:\d\d)$/.test(value || '') ? Date.parse(value) : NaN;
  const start = iso(config.start);
  const end = iso(config.end);
  const valid = config.enabled && config.linked && config.reference && /^[A-Za-z0-9_-]+$/.test(config.code) && end - start === 259200000;
  const originTime = performance.now();
  const now = () => Number(config.serverNow) * 1000 + performance.now() - originTime;
  if (!preview && (!valid || now() < start || now() >= end)) return;
  const panel = document.getElementById('G24ThankyouPreview');
  const output = panel?.querySelector('output');
  if (preview && !panel) return;
  const key = preview ? 'green24.thankyou.preview.v1' : 'green24.thankyou.v1';
  const read = () => { try { return JSON.parse(localStorage.getItem(key)) || {}; } catch (_) { return {}; } };
  let state = read();
  let storageAvailable = true;
  const save = () => { try { localStorage.setItem(key, JSON.stringify(state)); } catch (_) { storageAvailable = false; } };
  let mode = preview ? requested : 'both';
  let deadline = preview ? now() + 259200000 : end;
  let open = false;
  let stopped = false;
  let commerceIntent = false;
  let previous = performance.now();
  let lastOutsideFocus = document.activeElement;
  const visible = element => element && !element.closest('[hidden],[aria-hidden="true"],[inert]') && getComputedStyle(element).display !== 'none' && getComputedStyle(element).visibility !== 'hidden' && element.getClientRects().length > 0;
  const purchaseSelectors = '.g24-purchase-panel,green24-sticky-purchase,product-info .product-form__buttons,product-info [name="add"]';
  const purchaseInView = () => Array.from(document.querySelectorAll(purchaseSelectors)).some(element => {
    if (!visible(element)) return false;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
  });
  const blocked = () => {
    if (commerceIntent || commerceURL(location.href)) return true;
    if (purchaseInView()) return true;
    if (document.querySelector('#g24-notdienst-root,cart-drawer.active,cart-notification.active,.drawer.active,.menu-opening')) return true;
    if (document.activeElement && !card.contains(document.activeElement) && /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)) return true;
    const selectors = 'dialog[open],[role="dialog"],[aria-modal="true"],cart-drawer.active,cart-notification.active,.drawer.active,.menu-opening,#G24AE22Drawer:not([aria-hidden="true"]),#shopify-pc__banner,#shopify-pc__prefs,#onetrust-banner-sdk,#CybotCookiebotDialog,details[open] .modal__content';
    return Array.from(document.querySelectorAll(selectors)).some(element => !card.contains(element) && visible(element));
  };
  const active = () => document.visibilityState === 'visible' && (preview || document.hasFocus());
  const eligible = () => !stopped && now() < deadline && (preview || valid && now() >= start) && (preview || storageAvailable) && !(state.closedUntil > now()) && !(state.activatedUntil > now());
  const refreshVisit = () => {
    if (!(state.visitUntil > now())) state = {closedUntil: state.closedUntil || 0, activatedUntil: state.activatedUntil || 0, activeMs: 0, shown: false};
    state.visitUntil = now() + 1800000;
  };
  refreshVisit();
  save();
  const status = text => { if (preview && output) output.textContent = text; };
  const show = () => {
    if (open || state.shown || !eligible() || !active() || blocked()) return false;
    state = {...read(), ...state};
    if (!preview && read().shown && read().visitUntil > now()) return false;
    state.shown = true;
    save();
    if (!preview && !storageAvailable) return false;
    open = true;
    card.hidden = false;
    status(config.copy.shown);
    return true;
  };
  const dismiss = () => {
    if (!open) return;
    const restore = card.contains(document.activeElement);
    state.closedUntil = now() + 604800000;
    save();
    card.hidden = true;
    open = false;
    status(config.copy.closed);
    if (restore && lastOutsideFocus && lastOutsideFocus.isConnected && lastOutsideFocus !== document.body) lastOutsideFocus.focus({preventScroll: true});
  };
  card.querySelector('[data-g24-close]').addEventListener('click', dismiss);
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && open && !blocked()) dismiss(); });
  const commerceControls = '#cart-icon-bubble,[name="checkout"],.additional-checkout-buttons,shopify-accelerated-checkout,shopify-accelerated-checkout-cart';
  const hideForCommerce = () => { commerceIntent = true; card.hidden = true; open = false; };
  document.addEventListener('click', event => {
    const target = event.target;
    const link = target?.closest?.('a[href]');
    if (target?.closest?.(commerceControls) || link && commerceURL(link.href)) hideForCommerce();
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout' || commerceURL(event.target?.action)) hideForCommerce();
  }, true);
  document.addEventListener('focusin', event => {
    if (event.target?.closest?.(commerceControls)) hideForCommerce();
    if (!card.contains(event.target) && !panel?.contains(event.target)) lastOutsideFocus = event.target;
  });
  window.addEventListener('blur', () => { if (document.activeElement?.closest?.(commerceControls)) hideForCommerce(); });
  window.addEventListener('pagehide', () => { card.hidden = true; open = false; });
  const link = card.querySelector('[data-g24-activate]');
  if (!preview) {
    const redirect = new URL(location.href);
    redirect.searchParams.delete('g24_layer_preview');
    link.href = '/discount/' + encodeURIComponent(config.code) + '?redirect=' + encodeURIComponent(redirect.pathname + redirect.search + redirect.hash);
    const time = card.querySelector('time');
    time.dateTime = config.end;
    time.textContent = new Intl.DateTimeFormat(config.locale, {dateStyle: 'short', timeStyle: 'short', timeZone: 'Europe/Berlin'}).format(new Date(end));
  } else {
    card.dataset.preview = 'true';
    panel.hidden = false;
    card.querySelector('[data-g24-preview-badge]').hidden = false;
    card.querySelector('[data-g24-end]').hidden = true;
    link.href = '#G24ThankyouPreview';
  }
  link.addEventListener('click', event => {
    if (!open || !eligible() || blocked()) { event.preventDefault(); return; }
    state.activatedUntil = deadline;
    save();
    if (preview) { event.preventDefault(); status(config.copy.activated); }
    card.hidden = true;
    open = false;
  });
  const handleExit = event => {
    if (mode === 'time' || mode === 'layout' || event.relatedTarget !== null || event.clientY > 0 || state.activeMs < 20000 || innerWidth < 768 || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    show();
  };
  document.addEventListener('mouseout', handleExit);
  const protect = () => {
    if (open && (!eligible() || blocked())) { card.hidden = true; open = false; }
  };
  const purchaseObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver(protect) : null;
  const observedPurchases = new Set();
  const watchPurchases = () => {
    if (!purchaseObserver) return;
    const current = new Set(document.querySelectorAll(purchaseSelectors));
    observedPurchases.forEach(element => {
      if (!current.has(element)) { purchaseObserver.unobserve(element); observedPurchases.delete(element); }
    });
    current.forEach(element => {
      if (!observedPurchases.has(element)) { purchaseObserver.observe(element); observedPurchases.add(element); }
    });
  };
  watchPurchases();
  document.addEventListener('scroll', protect, {capture: true, passive: true});
  window.addEventListener('resize', protect, {passive: true});
  window.addEventListener('popstate', protect);
  window.addEventListener('pageshow', protect);
  let queued = false;
  const observer = new MutationObserver(() => {
    protect();
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; watchPurchases(); protect(); });
  });
  observer.observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'open', 'hidden', 'aria-hidden', 'aria-modal']});
  window.addEventListener('storage', event => {
    if (event.key !== key) return;
    const updated = read();
    if (updated.closedUntil > now() || updated.activatedUntil > now() || !state.shown && updated.shown) { card.hidden = true; open = false; }
    state = updated;
  });
  const tick = () => {
    const current = performance.now();
    const delta = Math.min(current - previous, 1500);
    previous = current;
    protect();
    if (now() >= deadline) {
      stopped = true;
      status(config.copy.expired);
      if (!preview) { clearInterval(timer); observer.disconnect(); purchaseObserver?.disconnect(); }
      return;
    }
    if (!active()) return;
    refreshVisit();
    state.activeMs = (state.activeMs || 0) + delta;
    save();
    if (preview && !open && !state.shown && !stopped) status(config.copy.waiting + ' ' + Math.floor(state.activeMs / 1000) + ' s · ' + mode);
    if (mode === 'layout' || mode !== 'exit' && state.activeMs >= 60000) show();
  };
  let timer = setInterval(tick, 1000);
  if (preview) {
    panel.querySelector('[data-g24-exit-test]').addEventListener('click', () => handleExit({relatedTarget: null, clientY: 0}));
    panel.querySelectorAll('[data-g24-mode]').forEach(button => button.addEventListener('click', () => {
      mode = button.dataset.g24Mode;
      stopped = false;
      deadline = now() + 259200000;
      state = {};
      refreshVisit();
      save();
      card.hidden = true;
      open = false;
      previous = performance.now();
      tick();
    }));
    panel.querySelector('[data-g24-expire]').addEventListener('click', () => { deadline = now(); tick(); });
    tick();
  }
})();
